import { render } from "./typeEfficiency.html?vue&type=template&id=f7f6b7a2&scoped=true&ts=true"
import script from "./typeEfficiency.ts?vue&type=script&lang=ts"
export * from "./typeEfficiency.ts?vue&type=script&lang=ts"

import "./typeEfficiency.scss?vue&type=style&index=0&id=f7f6b7a2&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f6b7a2"]])

export default __exports__